import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityAppUsersByAppIdSlice } from './get';

export const coreDataSecurityAppUsersByAppIdReducers = combineReducers({
	get: getCoreDataSecurityAppUsersByAppIdSlice.asyncReducers
});

export const coreDataSecurityAppUsersByAppIdWatchers = combineAllWatchers([
	getCoreDataSecurityAppUsersByAppIdSlice.asyncWatchers
]);
